import React from 'react';
import styled from 'react-emotion';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import Posts from './Posts';
import BlogHeader from './BlogHeader';
import MaxWidth from '../Layout/MaxWidth';
import Products from './Products';
import theme from '@jetshop/ui/utils/theme';
import Head from '@jetshop/core/components/Head';

import Breadcrumbs from '../Layout/Breadcrumbs';
import LeftAsideWithDropdown, {
  CategoryTreeWithSlidedown
} from './LeftAsideWithDropdown';

import { Content as BlogWrapper } from '../Layout/Layout';

const Container = styled(MaxWidth)`
  padding: 10px 20px 0;
  background: ${theme('colors.white')};
`;

const BlogContent = styled('div')`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled('div')`
  display: flex;
`;

const BlogPostWrapper = styled.div`
  max-width: 700px;
  padding: 0 5px;
`;

const Post = ({ category }) => {
  return (
    <BlogPostWrapper>
      <BlogHeader category={category} />
      <BlogContent>
        <Products products={category.products} />
      </BlogContent>
    </BlogPostWrapper>
  );
};

export default ({ category }) => {
  const isPost = category.images && category.images.length > 0;
  const breadcrumbProps = category.primaryRoute
    ? {
        breadcrumbText: category.breadcrumbText,
        parents: category.primaryRoute.parents
      }
    : null;

  return (
    <Container>
      <Head data={category.head} />
      <Breadcrumbs {...breadcrumbProps} />
      <Wrapper>
        <Above breakpoint="lg">
          <LeftAsideWithDropdown category={category} />
        </Above>
        <BlogWrapper>
          <Below breakpoint="lg">
            <CategoryTreeWithSlidedown category={category} />
          </Below>
          {isPost ? (
            <Post category={category} />
          ) : (
            <Posts category={category} />
          )}
        </BlogWrapper>
      </Wrapper>
    </Container>
  );
};
